// extracted by mini-css-extract-plugin
export default {"parrot":"AllQuotes_parrot__CNTot"};